import { useState } from 'react';

import { FormPhongBan } from '../components/FormPhongBan';
import type { CheDoForm } from '../components/FormPhongBan';
import { HopXoaPhongBan } from '../components/HopXoaPhongBan';
import type { Department } from '../types';
import { useSuaPhongBan, useTaoPhongBan, useXoaPhongBan } from './usePhongBan';

const CHE_DO_TAO: CheDoForm = { loai: 'tao', cha: null };

/**
 * Hộp thoại và mutation của các thao tác trên phòng ban — thêm (ở gốc hoặc
 * dưới một phòng ban), sửa, xoá. Cùng khuôn `useThaoTacVaiTro`: trả hàm mở
 * từng việc và `hopThoai` để view đặt vào cây.
 *
 * Mỗi lần mở tăng `lan`, dùng làm `key`: form dựng lại sạch mà không cần
 * effect đồng bộ.
 */
export function useThaoTacPhongBan(dsPhongBan: readonly Department[]) {
  const tao = useTaoPhongBan();
  const sua = useSuaPhongBan();
  const xoa = useXoaPhongBan();

  const [hopForm, setHopForm] = useState<{ mo: boolean; lan: number; cheDo: CheDoForm }>({
    mo: false,
    lan: 0,
    cheDo: CHE_DO_TAO,
  });
  const [hopXoa, setHopXoa] = useState<{ mo: boolean; phongBan: Department | null }>({
    mo: false,
    phongBan: null,
  });

  const moForm = (cheDo: CheDoForm) => setHopForm((h) => ({ mo: true, lan: h.lan + 1, cheDo }));
  const dongForm = () => setHopForm((h) => ({ ...h, mo: false }));
  const dongXoa = () => {
    setHopXoa((h) => ({ ...h, mo: false }));
    xoa.reset();
  };

  const hopThoai = (
    <>
      <FormPhongBan
        key={`form-${hopForm.lan}`}
        cheDo={hopForm.cheDo}
        dsPhongBan={dsPhongBan}
        open={hopForm.mo}
        dangLuu={tao.isPending || sua.isPending}
        onClose={dongForm}
        onTao={(du) => tao.mutateAsync(du).then(dongForm)}
        onSua={(id, du, etag) => sua.mutateAsync({ id, du, etag }).then(dongForm)}
      />
      <HopXoaPhongBan
        open={hopXoa.mo}
        phongBan={hopXoa.phongBan}
        dangChay={xoa.isPending}
        loi={xoa.error}
        onClose={dongXoa}
        onXacNhan={(pb) => xoa.mutate(pb, { onSuccess: () => setHopXoa((h) => ({ ...h, mo: false })) })}
      />
    </>
  );

  return {
    moTao: () => moForm(CHE_DO_TAO),
    moTaoCon: (cha: Department) => moForm({ loai: 'tao', cha }),
    moSua: (phongBan: Department) => moForm({ loai: 'sua', phongBan }),
    moXoa: (phongBan: Department) => {
      // Lỗi của lần trước (có thể của phòng ban khác) không được hiện ở hộp mới.
      xoa.reset();
      setHopXoa({ mo: true, phongBan });
    },
    hopThoai,
  };
}
